/**
 * Locale and time formatting (A00 discipline 22).
 *
 * Instants are pinned to Africa/Nairobi so a timestamp never rolls a day with the reader's device zone,
 * and formatted through `Intl` with an explicit en-KE locale rather than device defaults. Money is a
 * string the backend already formatted; NO arithmetic on money happens here or anywhere in the UI, so a
 * value can never become an IEEE-754 double on the way to a screen. This mirrors the backend `Money`
 * rule.
 */

const NAIROBI = 'Africa/Nairobi';

const F = {
  date: new Intl.DateTimeFormat('en-KE', {
    timeZone: NAIROBI,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }),
  dateShort: new Intl.DateTimeFormat('en-KE', {
    timeZone: NAIROBI,
    day: 'numeric',
    month: 'short',
  }),
  time: new Intl.DateTimeFormat('en-KE', { timeZone: NAIROBI, hour: 'numeric', minute: '2-digit' }),
  dateTime: new Intl.DateTimeFormat('en-KE', {
    timeZone: NAIROBI,
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }),
};

function safe(iso: string, fmt: Intl.DateTimeFormat): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : fmt.format(d);
}

/** "5 Aug 2026". */
export const fmtDate = (iso: string) => safe(iso, F.date);
/** "5 Aug". */
export const fmtDateShort = (iso: string) => safe(iso, F.dateShort);
/** "3:30 PM". */
export const fmtTime = (iso: string) => safe(iso, F.time);
/** "5 Aug 2026, 3:30 PM". */
export const fmtDateTime = (iso: string) => safe(iso, F.dateTime);

/** Prepend the currency code to an already-formatted decimal string. Never does arithmetic. */
export const kes = (amount: string) => `KES ${amount}`;
